{
  "actions": {
    "back": "Back",
    "home": "Home",
    "continue": "Continue",
    "cancel": "Cancel",
    "save": "Save",
    "close": "Close"
  },
  "labels": {
    "parent": "Parent",
    "kid": "Kid",
    "language": "Language"
  },
  "locales": {
    "en": "English",
    "es": "Español",
    "zh-cn": "简体中文",
    "zh-hant": "繁體中文"
  },
  "status": {
    "loading": "Loading..."
  },
  "errors": {
    "somethingWentWrong": "Something went wrong. Please try again."
  }
}
